import $ from "jquery";
import "magnific-popup";

class Gallery {
    constructor() {
        this.bindEvents();
    }

    bindEvents() {
        let that = this;
        if ($('.popup-gallery').length != 0) {
            $('.popup-gallery').magnificPopup({
                delegate: 'a',
                type: 'image',
                callbacks: {
                elementParse: function(item) {
                    console.log(item);
                    if(item.el.className == 'video') {
                    item.type = 'iframe',
                    item.iframe = {
                        patterns: {
                        youtube: {
                            index: 'youtube.com/',
            
                            id: 'v=',
            
                            src: '//www.youtube.com/embed/%id%?autoplay=1' 
                        },
                        vimeo: {
                            index: 'vimeo.com/',
                            id: '/',
                            src: '//player.vimeo.com/video/%id%?autoplay=1'
                        },
                        gmaps: {
                            index: '//maps.google.',
                            src: '%id%&output=embed'
                        }
                        }
                    }
                    } else {
                    item.type = 'image',
                    item.tLoading = 'Loading image #%curr%...',
                    item.mainClass = 'mfp-img-mobile',
                    item.image = {
                        tError: '<a href="%url%">The image #%curr%</a> could not be loaded.'
                    }
                    }
            
                }
                },
                gallery: {
                    enabled: true,
                    navigateByImgClick: true,
                    preload: [0,1] // Will preload 0 - before current, and 1 after the current image
                }
            
            });
        }
    }
}

export default new Gallery;